
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.99984 5.74V5.55C9.99984 4.87 9.28984 4.44 8.67984 4.73C8.48984 4.82 8.31984 4.93 8.13984 5.03L9.59984 6.49C9.83984 6.31 9.99984 6.04 9.99984 5.74ZM19.9998 12C19.9998 9.79 19.0898 7.8 17.6398 6.36L19.1498 4.85C19.4598 4.54 19.2398 4 18.7898 4H13.9998V8.79C13.9998 9.24 14.5398 9.46 14.8498 9.14L16.2398 7.75C17.3198 8.85 17.9998 10.34 17.9998 12C17.9998 12.85 17.8198 13.66 17.4998 14.39L18.9798 15.87C19.6198 14.72 19.9998 13.41 19.9998 12ZM3.56984 4.7C3.17984 5.09 3.17984 5.72 3.56984 6.11L5.21984 7.76C4.44984 9 3.99984 10.44 3.99984 12C3.99984 14.21 4.90984 16.2 6.35984 17.64L4.84984 19.15C4.53984 19.46 4.75984 20 5.20984 20H9.49984C9.77984 20 9.99984 19.78 9.99984 19.5V15.21C9.99984 14.76 9.45984 14.54 9.14984 14.86L7.75984 16.25C6.67984 15.15 5.99984 13.66 5.99984 12C5.99984 11 6.25984 10.07 6.68984 9.24L14.7598 17.31C14.7498 17.33 14.7498 17.33 14.7498 17.35C14.3198 17.47 13.9998 17.83 13.9998 18.26V18.44C13.9998 19.12 14.7098 19.55 15.3198 19.26C15.6298 19.12 15.9298 18.95 16.2198 18.77L18.0898 20.64C18.4798 21.03 19.1098 21.03 19.4998 20.64C19.8898 20.25 19.8898 19.62 19.4998 19.23L4.97984 4.7C4.58984 4.31 3.95984 4.31 3.56984 4.7Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sync-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSyncDisabled

    ```js
    <b-new-b-icon-sync-disabled />
    ```
</docs>


